import { useEffect } from 'react';

// TODO: https://leveltravel.atlassian.net/browse/LT-29389 удалить из проекта и заменить на аналог из usehooks-ts
/**
 * @deprecated
 */
const useTimeout = (callback: () => void, timeout: number, depArr?: any[]) =>
  useEffect(() => {
    const timer = setTimeout(() => {
      callback();
    }, timeout);
    return () => clearTimeout(timer);
  }, depArr);

export default useTimeout;
